import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get, getForUrlWithAuth, post } from "../../api";
import { page_limit_mytrip } from "utils";
const { TRIP_LIST, TRIP_DETAIL, TRIP_INVOICE } = Routes;

/*******************
@purpose :  get past current and upcoming trips
@Parameter : {flag}
@Author : INIC
******************/
export const getTripData =
  (flag, loader = true) =>
  (dispatch) => {
    return get(
      `${TRIP_LIST}/${flag}?page_limit=${page_limit_mytrip}`,
      false,
      loader
    ).then((res) => {
      if (res?.data) {
        dispatch(clearUserTrips(flag));
        dispatch(setUserTrips(res, flag));
        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
  };

/*******************
@purpose :  Get load more data
@Parameter : {url,flag}
@Author : INIC
******************/
export const getLoadMoreTripData = (url, flag) => (dispatch) => {
  return getForUrlWithAuth(
    `${url}&page_limit=${page_limit_mytrip}`,
    false,
    true
  ).then((res) => {
    if (res?.data) {
      dispatch(setUserTrips(res, flag));
      return Promise.resolve(res);
    }
    return Promise.reject(res);
  });
};

/*******************
@purpose :  get current trip
@Parameter : {tripId}
@Author : INIC
******************/
export const getSingleTripData =
  (tripId, loader = true) =>
  (dispatch) => {
    return get(`${TRIP_DETAIL}/${tripId}`, false, loader).then((res) => {
      if (res?.statusCode == 200) {
        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
  };

/*******************
@purpose :  send invoice mail
@Parameter : {tripId}
@Author : INIC
******************/
export const invoiceMail = (tripId) => (dispatch) => {
  return post(`${TRIP_INVOICE}/${tripId}`, false, false, false).then((res) => {
    if (res?.data) {
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/********************
@purpose : Used for set trip data to reducer
@Parameter : { token }
@Author : INIC
******************/
export const setUserTrips = (data, flag) => {
  let setType = "";
  if (flag == "past") {
    setType = types.SET_PAST_TRIPS;
  } else if (flag == "current") {
    setType = types.SET_CURRENT_TRIPS;
  } else {
    setType = types.SET_FUTURE_TRIPS;
  }
  return {
    type: setType,
    data: data,
  };
};

/********************
@purpose : Used for set trip data to reducer
@Parameter : { token }
@Author : INIC
******************/
export const clearUserTrips = (flag) => {
  let setType = "";
  if (flag == "past") {
    setType = types.CLEAR_PAST_TRIPS;
  } else if (flag == "current") {
    setType = types.CLEAR_CURRENT_TRIPS;
  } else {
    setType = types.CLEAR_FUTURE_TRIPS;
  }
  return {
    type: setType,
  };
};
